// listen to cart

(function () {
  if (!window || !window.Shopify) return;

  const CartEvents = {
    add: "SCE:add",
    update: "SCE:update",
    change: "SCE:change",
    clear: "SCE:clear",
    mutate: "SCE:mutate",
  };

  const ShopifyCartURLs = [
    "/cart/add",
    "/cart/update",
    "/cart/change",
    "/cart/clear",
    "/cart/add.js",
    "/cart/update.js",
    "/cart/change.js",
    "/cart/clear.js",
  ];

  function isShopifyCartURL(url) {
    if (!url) return false;
    const path = url.split("/").pop();
    return ShopifyCartURLs.includes(`/cart/${path}`);
  }

  function updateType(url) {
    if (!url) return false;
    if (url.includes("cart/add")) {
      return "add";
    } else if (url.includes("cart/update")) {
      return "update";
    } else if (url.includes("cart/change")) {
      return "change";
    } else if (url.includes("cart/clear")) {
      return "clear";
    } else return false;
  }

  function dispatchEvent(url, detail) {
    if (typeof detail === "string") {
      try {
        request = url;
        detail = JSON.parse(detail);
      } catch {}
    }

    window.dispatchEvent(new CustomEvent(CartEvents.mutate, { detail }));
    const type = updateType(url);
    switch (type) {
      case "add":
        window.dispatchEvent(new CustomEvent(CartEvents.add, { detail }));
        break;
      case "update":
        window.dispatchEvent(new CustomEvent(CartEvents.update, { detail }));
        break;
      case "change":
        window.dispatchEvent(new CustomEvent(CartEvents.change, { detail }));
        break;
      case "clear":
        window.dispatchEvent(new CustomEvent(CartEvents.clear, { detail }));
        break;
      default:
        break;
    }
  }

  function XHROverride() {
    if (!window.XMLHttpRequest) return;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function () {
      const url = arguments[1];
      // console.log(url);
      this.addEventListener("load", function () {
        if (isShopifyCartURL(url)) {
          
          dispatchEvent(url, this.response);
        }
      });
      
      
      return originalOpen.apply(this, arguments);
    };
  }

  function fetchOverride() {
    
    if (!window.fetch || typeof window.fetch !== "function") return;
    const originalFetch = window.fetch;
    let cart;
    
    window.fetch = function () {
      
      const response = originalFetch.apply(this, arguments);
      let get_id;
      let past_cart;
      
      if (isShopifyCartURL(arguments[0])) {
        fetch('/cart.js')
            .then(response => response.json())
            .then(d => {
              past_cart = d;
            })
            .catch(err => console.error(err));
        
        response.then((res) => {
          res
            .clone()
            .json()
            .then((data) => {
              // console.log(arguments);
              
              data.request = arguments[1];
              data.past_items = past_cart;
              data.operation_url = res.url;
              dispatchEvent(res.url, data)
            });
        });
      }

      return response;
    };
  }

  fetchOverride();
  XHROverride();
})();

// cookie manager

class CookieManager {
  static setCookie({ name = "", days = 0, value = "", path = "/" }) {
    
      let expire = "";
      if (days) {
          const date = new Date();
          date.setTime(date.getTime() + days * 1000 * 60 * 60 * 24);
          expire = date.toUTCString();
      }
      document.cookie = `${name}=${value}; expires=${expire}; path=${path}`;
  }

  static getCookie({ name }) {
      name = name.trim();
      const allCookie = document.cookie;
      const cookieArr = [...allCookie.split(";")];
      for (let i = 0; i < cookieArr.length; i++) {
          let c = cookieArr[i].trim();
          if (c.startsWith(`${name}=`)) return c.split("=")[1];
      }
      return null;
  }

  static removeCookie({ name = "" }) {
      CookieManager.setCookie({ name, days: -1 });
  }

  static checkCookie({ name = "" }) {
      const cookie = CookieManager.getCookie({ name: name });
      if (cookie !== undefined && cookie !== "" && cookie !== null) {
          return true;
      } else {
          return false;
      }
  }
}



// run upsell

$(window).on('load', () => {
  const body = document.querySelector('body');
  if (body.classList.contains('template-cart')) {
    upsellProduct();
  }
})

$(window).on('SCE:mutate', () => {
  upsellProduct();
});

function stopPr() {
  const blocks = document.querySelectorAll('.stop-propagation');
  if (blocks) {
    
    blocks.forEach(el => {
      el.addEventListener('click', function(e){
        e.stopPropagation();
        e.preventDefault();
        const form = el.closest('form');
        const qty = form.querySelector('.qty-adjuster__value').value;
        const variant = form.querySelector('.original-selector').value;
        data = {
          "id": variant,
          "quantity": qty
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function(e) { 
            window.location.href = '/cart';
          }
        });
      })
    })
  }
}
stopPr();

function updateCartFromList() {
  const blocks = document.querySelectorAll('.product_slider');
  if (blocks.length > 0) {
    blocks.forEach(block => {
      const forms = block.querySelectorAll('.product-form-in-list');
      forms.forEach(el => {
        // const form = new FormData(e);
        $(el).submit(function(e){
          data = { 
            "id": e.currentTarget[3].value,
            "quantity": e.currentTarget[2].value
          }
          e.preventDefault();
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function(e) { 
              theme.updateCartSummaries();
            }
          });
        })
      })
    })
    
  }
}
updateCartFromList();

function upsellProduct() {
  const upsell_product = document.querySelector('body').dataset.upsell;
  const popup = document.querySelector('.opkl-upsell');
  const close = popup.querySelector('.close');
  const overlay = popup.querySelector('.overlay');
  const variants = popup.querySelectorAll('.variants input');
  const slider = popup.querySelector('.product-slideshow');
  const currentPrice = popup.querySelector('.current-price');
  const product = popup.querySelector('[name="id"]');
  if (variants.length > 0) {
    variants.forEach(e => {
      e.addEventListener('change', () => {
        const slide = popup.querySelector(`[data-media-id="${e.dataset.image}"]`).dataset.slickIndex;
        $(slider).slick('slickGoTo', slide);
        currentPrice.textContent = e.dataset.price;
        product.value = e.id;
      })
    })
  }
  [close, overlay].forEach(e => {
    $(e).on('click', () => {
      $(popup).fadeOut();
    })
  })
  fetch('/cart.js')
  .then(res => res.json())
  .then(data => {
    // console.log(data);
    const count = data.item_count;
    // console.log(count);
    let check_in = false;
    let cookie_value = {
      'is_set': 'true' 
    };
    if (count) {
      data.items.forEach(e => {
        if (e.id == upsell_product) {
          check_in = true;
        }
      });
      if (!CookieManager.checkCookie({name: "opkl_upsell"}) && !check_in) {
        setTimeout(function(){
          $(popup).fadeIn();
          $(slider).slick('refresh');
        }, 1000);
        
      }
      
    } else {
      CookieManager.removeCookie({name:"opkl_upsell"});
      // console.log('to remove');
    }
    
    
    
  })
  .catch(err => console.log(err));
}